import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFact',
  props: {
    title: null,
    componentName: null,
    prerender: { type: Boolean },
    factId: null
  },
  setup(__props: any) {



const borderColor = computed<OpacityFunction>(() => store.getters['app/borderColor']);

const expanded = ref<boolean>(false);

const panelClass = computed<string>(() => 'u-py-16p u-text-ellipsis u-cursor-pointer u-text-medium u-font-normal u-relative u-border-t ' + borderColor.value(25));

function expandedChange(expandedValue: boolean): void {
    expanded.value = expandedValue;
}

return { __sfc: true,borderColor, expanded, panelClass, expandedChange }
}

})